import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import '../FishFinderBuilder.css';
import TopNavBar from './TopNavBar';
import Footer from './Footer';

const SharedLayout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className={`shared-layout ${isHomePage ? 'home-page' : ''}`} style={{ 
      backgroundColor: '#000000', 
      minHeight: '100vh', 
      color: '#ffffff',
      padding: 0,
      margin: 0,
      width: '100%',
      maxWidth: '100%'
    }}>
      {!isHomePage && <TopNavBar />}
      <main className="shared-main" style={{ 
        backgroundColor: '#000000', 
        padding: 0, 
        margin: 0, 
        maxWidth: '100%',
        width: '100%',
        color: '#ffffff'
      }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default SharedLayout; 